import { ApplicationState } from "../index";

export function getById(id: string) {
  return (state: ApplicationState) =>
    state.cardType.data?.data?.find((x) => x.id === id);
}
